/* Llongueras · Landing "Tinte sin amoniaco" — carrusel y vídeo */
(function () {
  function initCarousel(root) {
    if (root.dataset.llReady) return;
    root.dataset.llReady = '1';
    var track = root.querySelector('[data-ll-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var prev = root.querySelector('[data-ll-prev]');
    var next = root.querySelector('[data-ll-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ll-dot]'));

    function step() {
      return slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : track.clientWidth;
    }
    function maxScroll() { return track.scrollWidth - track.clientWidth - 2; }
    function index() {
      if (track.scrollLeft >= maxScroll()) return slides.length - 1;
      return Math.round(track.scrollLeft / step());
    }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * step(), behavior: 'smooth' });
    }
    function update() {
      var i = index();
      dots.forEach(function (d, j) { d.setAttribute('aria-current', i === j ? 'true' : 'false'); });
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= maxScroll();
    }
    if (prev) prev.addEventListener('click', function () { go(index() - 1); });
    if (next) next.addEventListener('click', function () { go(index() + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { update(); ticking = false; });
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initVideo(root) {
    if (root.dataset.llReady) return;
    root.dataset.llReady = '1';
    var video = root.querySelector('video');
    var btn = root.querySelector('[data-ll-play]');
    if (!video || !btn) return;
    btn.addEventListener('click', function () {
      video.controls = true;
      video.play();
      btn.hidden = true;
    });
  }

  function initCompare(root) {
    if (root.dataset.llReady) return;
    root.dataset.llReady = '1';
    var range = root.querySelector('.ll-compare__range');
    var dragging = false;
    function set(pct) {
      pct = Math.max(0, Math.min(100, pct));
      root.style.setProperty('--pos', pct + '%');
      if (range) range.value = Math.round(pct);
    }
    function fromEvent(e) {
      var r = root.getBoundingClientRect();
      set(((e.clientX - r.left) / r.width) * 100);
    }
    root.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      e.preventDefault();
      dragging = true;
      root.classList.add('is-dragging');
      try { root.setPointerCapture(e.pointerId); } catch (err) {}
      fromEvent(e);
      if (range) range.focus({ preventScroll: true });
    });
    root.addEventListener('pointermove', function (e) { if (dragging) { e.preventDefault(); fromEvent(e); } });
    function stop() { dragging = false; root.classList.remove('is-dragging'); }
    root.addEventListener('pointerup', stop);
    root.addEventListener('pointercancel', stop);
    if (range) range.addEventListener('input', function () { set(parseFloat(range.value)); });
  }

  function initClamp(root) {
    if (root.dataset.llReady) return;
    root.dataset.llReady = '1';
    var text = root.querySelector('.ll-clamp__text');
    var btn = root.querySelector('.ll-clamp__btn');
    if (!text || !btn) return;
    function check() {
      if (root.classList.contains('is-open')) return;
      btn.hidden = text.scrollHeight <= text.clientHeight + 2;
    }
    btn.addEventListener('click', function () {
      var open = root.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? btn.dataset.less : btn.dataset.more;
    });
    check();
    window.addEventListener('resize', check);
  }

  function initFade(root) {
    if (root.dataset.llReady) return;
    root.dataset.llReady = '1';
    var slides = root.querySelectorAll('.ll-fade__slide');
    var dots = root.querySelectorAll('[data-ll-fade-dot]');
    var i = 0, timer = null;
    var secs = parseInt(root.dataset.interval || '0', 10);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, j) { s.classList.toggle('is-active', j === i); s.setAttribute('aria-hidden', j === i ? 'false' : 'true'); });
      dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    }
    function start() { if (secs > 0 && !reduce && !timer) timer = setInterval(function () { show(i + 1); }, secs * 1000); }
    function stop() { clearInterval(timer); timer = null; }
    dots.forEach(function (d, j) { d.addEventListener('click', function () { show(j); stop(); start(); }); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) { show(dx < 0 ? i + 1 : i - 1); stop(); start(); }
    });
    start();
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-ll-carousel]').forEach(initCarousel);
    scope.querySelectorAll('[data-ll-video]').forEach(initVideo);
    scope.querySelectorAll('[data-ll-compare]').forEach(initCompare);
    scope.querySelectorAll('[data-ll-clamp]').forEach(initClamp);
    scope.querySelectorAll('[data-ll-fade]').forEach(initFade);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
